// extracted by mini-css-extract-plugin
export default {"upVoteCount":"VotingModel_upVoteCount__MH9Zw","downVoteCount":"VotingModel_downVoteCount__Phfsg","container":"VotingModel_container__xUMVZ","icon":"VotingModel_icon__TL12j"};